import { render, staticRenderFns } from "./MyCompanyCategoriesNew.vue?vue&type=template&id=7ccbcfb2&"
import script from "./MyCompanyCategoriesNew.vue?vue&type=script&lang=js&"
export * from "./MyCompanyCategoriesNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports